import { makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor?: string;
}

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    textAlign: 'center',
    position: 'relative',
    minHeight: '60vh',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 600,
    marginBottom: '2rem',
    color: ({ primaryColor }: StyleProps) => primaryColor || '#000',
  },
  message: {
    fontSize: '1.1rem',
    marginBottom: '2rem',
    color: '#666',
  },
  imageContainer: {
    width: '100%',
    maxWidth: '300px',
    margin: '2rem auto',
  },
}));
